import React, {useState} from "react"
import PropTypes from "prop-types"

import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import idHelper from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"
import {Deal} from "@irati/types"
import {TextButton} from "@irati/ui/src/Button"
import RewardProductPreview from "./RewardProductPreview"

interface Props extends WithPerkOrReward {
  id: string,
  deal: Deal,
  onClick: () => any
}

const DealTileOnClick: React.FC<Props> = (
  {id, isWallet, isRewards, onClick, deal, children},
  {appPath, apps: {PERKS, FLEXIREWARDS, ADMIN}}
) => {
  if (isWallet || appPath === ADMIN) {
    const [show, setShow] = useState(false)
    return (
      <>
        <TextButton inline={false} onClick={() => setShow(true)}>
          {children}
        </TextButton>
        <RewardProductPreview show={show} deal={deal} onHide={() => setShow(false)} isAdmin={appPath === ADMIN} />
      </>
    )
  }

  const appLink = isRewards ? FLEXIREWARDS : PERKS
  return (
    <RouterLink
      id={idHelper("link-deal", id)}
      app={appLink}
      to={`/info/${deal.urlSlug}`}
      onClick={onClick}
      styled={false}>
      {children}
    </RouterLink>
  )
}

DealTileOnClick.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default withPerkOrReward(DealTileOnClick)
